export default __webpack_public_path__ + "static/media/overviewProjects.f0b65b58.png";